<legend class="label-form-cnaf">Les ressources nettes imposables cumulées des 12 derniers mois de votre enfant
    <ng-cnaf-aide idDiv="idInfoRessourcesPopup" alt="Informations spécifiques à ces champs" data-container="body" (click)="clickPopup()">
    </ng-cnaf-aide>
</legend>

    <p class="bloc-info">
        <img class="img-info" src="/icfstatiquesangularappli/dist/images/InformationsGris.png" alt="">
        <span class="texte-clair-cnaf" style="padding-left: 15px;margin: 0px;">
                Votre enfant est travailleur indépendant depuis moins deux ans. Vous devez indiquer dans la rubrique "Revenu ou déficit de travailleur indépendant"
                son chiffre d'affaires des 12 derniers mois après déduction de l'abattement lié à son activité <span style="white-space: nowrap">(artisan : 50%, commerçant : 71%,
                profession libérale : 34%, profession agricole : 87%).</span>
        </span>
    </p>

<div id="idInfoRessourcesPopup" class="d-none" role="tooltip" tabindex="-1" aria-hidden="true">
    <span>Le montant des ressources nettes imposables figure sur le justificatif de ressources dans la rubrique «Montant à déclarer». Vous ne devez pas déclarer le montant net qui est perçu.</span>
</div>

<div class="bloc-resultat-cnaf padding-bas-10" [formGroup]="ressourcesEnfantForm" novalidate autocomplete="off">

    <div *ngFor="let confRessource of listeConfRessources let idx = index" class="margin-left-10">
        <ccd-rubrique-montant
            name="{{confRessource.id}}"
            id="{{confRessource.id}}"
            libelle="{{confRessource.libelle}}"
            montantId="MONTANT_{{confRessource.id}}"
            montantPlaceHolder="{{confRessource.placeHolder}}"
            [montantValidators]="confRessource.validators"
            [montantMapErreurs]="montantMapErreurs"
            [rubriqueModel]="ressourcesEnfant.listeRessources[idx].rubriqueData">
        </ccd-rubrique-montant>
    </div>

</div>
